import { useState, useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import { loadRazorpay } from "../services/razorpayService";
import axios from "axios";
import "bootstrap-icons/font/bootstrap-icons.css";
import CryptoJS from "crypto-js";

function HappyCare() {
  const [searchParams] = useSearchParams();
  const [editModeldata, setEditModeldata] = useState("");

  const [isregister, setIsregister] = useState(false);

  const [pan, setPan] = useState("");
  const [error, setError] = useState("");

  const handlePanChange = (e) => {
    const value = e.target.value.toUpperCase();
    setEditModeldata({ ...editModeldata, parents_pan: value });
    setPan(value);

    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;

    if (value === "") {
      setError("");
    } else if (!panRegex.test(value)) {
      setError("Invalid PAN number");
    } else {
      setError("");
    }
  };

  const handleChangeziyafat = (e) => {
    const ziyafat = parseFloat(e.target.value) || 0;
    const total = ziyafat + 5300;

    setEditModeldata({
      ...editModeldata,
      ziyafat: e.target.value,
      total: total,
    });
  };

  const movetomainwebsite = () => {

    window.location.href = "https://www.its52.com/Istifada/Registration_Payment_Response.aspx?its=" + editModeldata.its + "&ut=" + editModeldata.ut + "&ps=True";

    // setTimeout(() => {
    //   window.location.href = "http://80.93.25.43/Istifada/Registration_Payment_Response.aspx?its=" + editModeldata.its + "&ut=" + editModeldata.ut + "&ps=True";
    // }, 1); // Redirect after 3 seconds
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!checkvalidation()) {
      return;
    }

    const loaded = await loadRazorpay();

    if (!loaded) {
      alert("Unable to load Razorpay");
      return;
    }

    try {
      const response = await axios.post(
        "https://api.almuntasebaat.in/api/Payment/create-order",
        {
          itsid: editModeldata.itsid,
          name: editModeldata.name,
          mobile: editModeldata.mobile,
          parentsitsid: editModeldata.parents_itsid,

          parentsname: editModeldata.parents_name,

          parentspannumber: editModeldata.parents_pan,
          registrationamount: 5300,
          ziyafatamount: editModeldata.ziyafat,
          totalamount: editModeldata.total,
          its:editModeldata.its,
          ut:editModeldata.ut,
        },
        {
          headers: {
            "X-API-KEY": "Almuntasebaat#520865",
          },
        },
      );

      openPayment(response.data);
    } catch (error) {
      console.log(error);

      alert("Payment initialization failed");
    }
  };

  const openPayment = (order) => {
    const options = {
      key: "rzp_live_TLbv9JWJbXcME2",

      amount: order.amount,

      currency: order.currency,

      order_id: order.id,

      name: "Happy Care Registration Portal",

      description: "Registration Fee -" + editModeldata.itsid,
      
      payment_capture:1,
      prefill: {
        name: editModeldata.name,

        contact: editModeldata.mobile,
      },

      theme: {
        color: "#0d6efd",
      },

      handler: async function (response) {
        console.log("razorpay response", response);
        /*
            response.razorpay_payment_id
            response.razorpay_order_id
            response.razorpay_signature
            */

        await saveRegistration(response);
      },

      modal: {
        ondismiss: function () {
          alert("Payment cancelled");
        },
      },
    };

    const paymentObject = new window.Razorpay(options);

    paymentObject.open();
  };

  const [getdata, setdata] = useState([]);

  const getregistration = async (itsid) => {
    try {
      const result = await axios.get(
        "https://api.almuntasebaat.in/api/Registration?itsidv=" + itsid,
        {
          headers: {
            "X-API-KEY": "Almuntasebaat#520865",
          },
        },
      );
      const data = result.data;
      setdata(data);
      console.log("dtaa", data);

      if (data[0].istatus == true) {
        setIsregister(true);
      }
    } catch {}
  };

 

  const saveRegistration = async (paymentData) => {
    const payload = {
      ...editModeldata,

      razorpayPaymentId: paymentData.razorpay_payment_id,

      razorpayOrderId: paymentData.razorpay_order_id,

      razorpaySignature: paymentData.razorpay_signature,
    };

    setIsregister(true);
    const result = await axios.post(
      "https://api.almuntasebaat.in/api/payment/verify-payment",

      {
        itsid: editModeldata.itsid,
        razorpayPaymentId: paymentData.razorpay_payment_id,

        razorpayOrderId: paymentData.razorpay_order_id || "",

        razorpaySignature: paymentData.razorpay_signature || "",
      },
      {
        headers: {
          "X-API-KEY": "Almuntasebaat#520865",
        },
      },
    );

    if (result.status === 200) {
      // setIsregister(false);
     // alert("Payment successful");
      movetomainwebsite();
    }
  };

  const checkvalidation = () => {
    if (
      !editModeldata.itsid ||
      !editModeldata.name ||
      !editModeldata.mobile ||
      !editModeldata.parents_itsid ||
      !editModeldata.parents_name ||
      !editModeldata.parents_pan ||
      !editModeldata.ziyafat ||
      editModeldata.ziyafat == 0
    ) {
      alert("Please fill all the fields");
      return false;
    } else if (error) {
      alert("Please enter a valid PAN number");
      return false;
    } else {
      return true;
    }
  };
const authTokenvalue = "K7mP9xQ2Ld8VzN4HaR1cWy6JtEf3UgBs5Xi0MoYk7CpDnL8ReQ";

const decryptString = (authToken, encryptedText) => {
  try {
    // Replace [HM] with +
    encryptedText = encryptedText.replace(/\[HM\]/g, "+");

    // MD5 hash of AuthToken
    const md5Key = CryptoJS.MD5(CryptoJS.enc.Utf8.parse(authToken));

    // Decrypt using TripleDES
    const decrypted = CryptoJS.TripleDES.decrypt(
      {
        ciphertext: CryptoJS.enc.Base64.parse(encryptedText),
      },
      md5Key,
      {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7,
      }
    );

    return decrypted.toString(CryptoJS.enc.Utf8);
  } catch (err) {
    console.error(err);
    return null;
  }
}

const encryptString = (authToken, plainText) => {
    try {
        // Generate MD5 key
        const key = CryptoJS.MD5(CryptoJS.enc.Utf8.parse(authToken));

        // Encrypt
        const encrypted = CryptoJS.TripleDES.encrypt(
            CryptoJS.enc.Utf8.parse(plainText),
            key,
            {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            }
        );

        // Convert to Base64
        return encrypted.ciphertext
            .toString(CryptoJS.enc.Base64)
            .replace(/\+/g, "[HM]");
    } catch (e) {
        console.error(e);
        return null;
    }
}

const getdumyecnrypted=()=>{

 const its=  encryptString(authTokenvalue, "30334597");
 const its1=  encryptString(authTokenvalue, "Husain Tashrifwala");
 const its2=  encryptString(authTokenvalue, "50477874");
 const its3=  encryptString(authTokenvalue, "Father's Name");
 const its4=  encryptString(authTokenvalue, "9898989899");
 const it5=  encryptString(authTokenvalue, "897987sdfasdfjksadjfsdfsdfsdf");

 console.log("encrpted", its +" : "+its1+" : "+its2+" : "+its3+" : "+its4+" : "+it5);

}


  useEffect(() => {
    const itsid = searchParams.get("its");
    const fullname = searchParams.get("name");
    const fitsid = searchParams.get("fits");
    const fname = searchParams.get("fname");
    const fmob = searchParams.get("fmob");
    const ut = searchParams.get("ut");

     const decryptedItsid = decryptString(authTokenvalue, itsid);
     const decryptedFullname = decryptString(authTokenvalue, fullname);
     const decryptedFitsid = decryptString(authTokenvalue, fitsid);
     const decryptedFname = decryptString(authTokenvalue, fname);
     const decryptedFmob = decryptString(authTokenvalue, fmob);
     const decryptedUt = decryptString(authTokenvalue, ut);
//getdumyecnrypted();
    getregistration(decryptedItsid);
  
    setEditModeldata({ ...editModeldata, itsid: decryptedItsid , name: decryptedFullname, parents_itsid: decryptedFitsid, parents_name: decryptedFname, mobile: decryptedFmob, ut: ut, its: itsid });
    

    // Call your API here
  }, []);
  return (
    <div className="container-xxl ">
      <div className="row align-items-center">
        <div className=" row col-md-12">
          <div className="col-md-2">
            <center>
              <img
                src="https://almuntasebaat.com/assets/images/slider/111.png"
                height={100}></img>
            </center>
          </div>
          <div className="col-md-8">
            <center>
              <h1 style={{color:"darkcyan", fontWeight:"bold"}}>Happy Care Registration Form</h1>
             
            </center>
          </div>

          <div className="col-md-2"></div>
        </div>
      </div>

      <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-sm-12 row d-flex mb-3">
        <div className="col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 col-sm-12 row d-flex mb-3"></div>

        {editModeldata.itsid ? 
<>
        {isregister ? (
          <div className="col-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8 col-sm-12 card m-2 p-3 border   bg-light">
            <div className="container d-flex justify-content-center align-items-center min-vh-100">
              <div
                className="card shadow-lg border-0 text-center p-5"
                style={{
                  maxWidth: "500px",
                  borderRadius: "20px",
                }}>
                <div className="mb-4">
                  <div
                    className="mx-auto d-flex justify-content-center align-items-center rounded-circle bg-success bg-opacity-10"
                    style={{
                      width: "100px",
                      height: "100px",
                    }}>
                    <i
                      className="bi bi-check-circle-fill text-success"
                      style={{
                        fontSize: "60px",
                      }}></i>
                  </div>
                </div>

                <h2 className="fw-bold text-success">Payment Successful!</h2>

                <p className="text-muted mt-3 mb-4">
                  Your registration has been completed successfully. Thank you
                  for your payment.
                </p>

                <div className="bg-light rounded p-3 mb-4"></div>

                <button
                  className="btn btn-success px-4 py-2"
                  onClick={movetomainwebsite}
                  // onClick={() => navigate("/")}
                >
                  Back to Home
                </button>
              </div>
            </div>
          </div>
        ) : (
          <div className="col-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8 col-sm-12 card m-2 p-3 border border-2 border-dark bg-happy">
            <div className="card-header">
              <center>
                
                <h6> Please fill out the
                form and make payment to register. </h6>
              </center>
            </div>

            <div className="card-body">
              <div className="mb-3 row">
                <div className="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col-sm-12">
                  <label htmlFor="name">Child ITSID:</label> 
                  {editModeldata.itsid?"":<span style={{color:"red"}}> * </span>}
                  <input
                    type="number"
                    className="form-control"
                    id="name"
                    disabled
                    onChange={(e) =>
                      setEditModeldata({
                        ...editModeldata,
                        itsid: e.target.value,
                      })
                    }
                    value={editModeldata.itsid || ""}
                    placeholder="Enter Child ITSID"
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col-sm-12">
                  <label htmlFor="name">Child Name:</label>
                    {editModeldata.name?"":<span style={{color:"red"}}> * </span>}
                  <input
                    type="text"
                    disabled
                    className="form-control"
                    id="name"
                    onChange={(e) =>
                      setEditModeldata({
                        ...editModeldata,
                        name: e.target.value,
                      })
                    }
                    value={editModeldata.name || ""}
                    placeholder="Enter Child name"
                  />
                </div>
              </div>

              <div className="mb-3 row">
                <div className="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col-sm-12">
                  <label htmlFor="name">Father ITSID:</label>
                    {editModeldata.parents_itsid?"":<span style={{color:"red"}}> * </span>}
                  <input
                    type="number"
                    className="form-control"
                    id="name"
                    disabled
                    onChange={(e) =>
                      setEditModeldata({
                        ...editModeldata,
                        parents_itsid: e.target.value,
                      })
                    }
                    value={editModeldata.parents_itsid || ""}
                    placeholder="Enter Father ITSID"
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col-sm-12">
                  <label htmlFor="name">Father Name:</label>
                    {editModeldata.parents_name?"":<span style={{color:"red"}}> * </span>}
                  <input
                    type="text"
                    disabled
                    className="form-control"
                    id="name"
                    onChange={(e) =>
                      setEditModeldata({
                        ...editModeldata,
                        parents_name: e.target.value,
                      })
                    }
                    value={editModeldata.parents_name || ""}
                    placeholder="Enter Father's name"
                  />
                </div>
              </div>

              <div className="mb-3 row">
                <div className="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col-sm-12">
                  <label htmlFor="name">Father's Mobile:</label>
                      {editModeldata.mobile?"":<span style={{color:"red"}}> * </span>}
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    
                    disabled={editModeldata.mobile ? true : false}
                    onChange={(e) =>
                      setEditModeldata({
                        ...editModeldata,
                        mobile: e.target.value,
                      })
                    }
                    value={editModeldata.mobile || ""}
                    placeholder="Enter Father's mobile number"
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col-sm-12">
                  <label htmlFor="name">Father's PAN Number:</label>
                    {editModeldata.parents_pan?"":<span style={{color:"red"}}> * </span>}
                  <input
                    type="text"
                    className="form-control"
                    maxLength={10}
                    value={pan}
                    onChange={handlePanChange}
                    placeholder="Enter PAN Number"
                  />

                  {error && <small className="text-danger">{error}</small>}
                  {/* <input type="text" className="form-control" id="name" onChange={(e) => setEditModeldata({...editModeldata, parents_pan: e.target.value})} value={editModeldata.parents_pan || ""} placeholder="Enter your parents' PAN number" /> */}
                </div>
              </div>

              <div className="mb-3 row">
                <div className="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col-sm-12">
                  <label htmlFor="name">Registration Amount :</label>
                  <input
                    type="text"
                    className="form-control"
                    id="name"
                    value="5300"
                    disabled
                    placeholder="Enter your name"
                  />
                </div>
                <div className="col-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 col-sm-12">
                  <label htmlFor="name">Ziyafat:</label>
                    {editModeldata.ziyafat?"":<span style={{color:"red"}}> * </span>}
                  <select
                    name="ziyafat"
                    value={editModeldata.ziyafat || "0"}
                    onChange={handleChangeziyafat}
                    className="form-select"
                    aria-label="Select Ziyafat">
                    <option value="0">Select Ziyafat</option>
                    <option value="1100">1100</option>
                    <option value="2100">2100</option>
                  </select>
                </div>
              </div>

              <div className="mb-3 row">
                <div className="col-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 col-sm-12">
                  <center>
                    <label htmlFor="name">Total Amount :</label>
                    <strong>{editModeldata.total || "5300"} INR</strong>
                  </center>
                </div>
              </div>
            </div>

            <div className="card-footer">
              <center>
                <button
                  type="submit"
                  onClick={handleSubmit}
                  className="col-4 btn-pink">
                  Pay Now
                </button>
              </center>
            </div>
          </div>
        )}
</>
        :
        
          <div className="col-12 col-md-8 col-lg-8 col-xl-8 col-xxl-8 col-sm-12 card m-2 p-3 border   bg-light">
            <div className="container d-flex justify-content-center align-items-center min-vh-100">
              <div
                className="card shadow-lg border-0 text-center p-5"
                style={{
                  maxWidth: "500px",
                  borderRadius: "20px",
                }}>
                <div className="mb-4">
                  <div
                    className="mx-auto d-flex justify-content-center align-items-center rounded-circle bg-danger bg-opacity-10"
                    style={{
                      width: "100px",
                      height: "100px",
                    }}>
                    <i
                      className="bi bi-exclamation-circle-fill text-danger"
                      style={{
                        fontSize: "60px",
                      }}></i>
                  </div>
                </div>

                <h2 className="fw-bold text-danger">You are Not Authorized for this Page !</h2>
                

                <div className="bg-light rounded p-3 mb-4"></div>

             
              </div>
            </div>
          </div>

        }
        <div className="col-12 col-md-2 col-lg-2 col-xl-2 col-xxl-2 col-sm-12 row d-flex mb-3"></div>
      </div>
    </div>
  );
}

export default HappyCare;
